"use client";

import Image from "next/image";
import { motion } from "motion/react";

interface CommunityHeroProps {
    name: string;
    image: string;
    location: string;
}

export function CommunityHero({ name, image, location }: CommunityHeroProps) {
    return (
        <section className="relative h-screen w-full overflow-hidden">
            {/* Background Image */}
            <div className="absolute inset-0">
                <Image
                    src={image}
                    alt={name}
                    fill
                    className="object-cover"
                    priority
                />
                <div className="absolute inset-0 bg-black/30" />
            </div>

            {/* Hero Content */}
            <div className="relative h-full container mx-auto px-6 md:px-12 flex flex-col justify-center items-center text-center text-white">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                >
                    <span className="text-sm md:text-base uppercase tracking-[0.3em] font-bold mb-4 block">
                        {location}
                    </span>
                    <h1 className="font-serif text-5xl md:text-7xl lg:text-6xl uppercase tracking-wider mb-6 leading-none">
                        {name}
                    </h1>
                    <div className="w-24 h-1 bg-white mx-auto mt-8 opacity-80" />
                </motion.div>
            </div>

            {/* Scroll Indicator */}
            <motion.div
                className="absolute bottom-12 left-1/2 -translate-x-1/2 text-white flex flex-col items-center gap-2"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 1, duration: 1 }}
            >
                <span className="text-[10px] uppercase tracking-[0.2em] mb-2">Scroll</span>
                <div className="w-[1px] h-12 bg-white/50 relative overflow-hidden">
                    <div className="absolute top-0 left-0 w-full h-1/2 bg-white animate-scroll-down" />
                </div>
            </motion.div>
        </section>
    );
}
